<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!currencyRate" key="no-currency-rate"/>
            <div v-else class="col-xl-8" key="currency-rate">
                <div class="row">
                    <div class="col-12 mb-4 d-sm-flex justify-content-between align-items-baseline">
                        <div class="pl-3">
                            <h4>
                                {{ isNew
                                ? 'New rate'
                                : `${currencyRate.from_code} - ${currencyRate.to_code}` }}
                            </h4>
                            <p class="mb-0 text-muted" v-if="!isNew">
                                <small>Created on {{ currencyRate.created_at | date }}</small>
                            </p>
                        </div>
                        <div class="col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
                            <button class="btn btn-primary mr-2"
                                    :disabled="loading"
                                    @click="save">
                                Save
                            </button>
                            <button class="btn btn-outline-secondary"
                                    :disabled="loading"
                                    @click="saveAndClose">
                                Save & close
                            </button>
                            <b-dropdown variant="link"
                                        no-caret
                                        right
                                        v-if="!isNew">
                                <template v-slot:button-content>
                                    <i class="material-icons">more_vert</i>
                                </template>
                                <b-dropdown-item :disabled="loading"
                                                 @click="destroy">
                                    Delete
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <AppSelect :value="currencyRate.currency_from"
                                       :options="currencies"
                                       track-by="code"
                                       label-field="code"
                                       label="From currency"
                                       placeholder=""
                                       field="from_code"
                                       :errors="errors"
                                       @input="updateCurrencyRateProps({
                                       currency_from: $event,
                                       from_code: $event ? $event.code : null,
                                       })"
                                       class="col-sm-6 col-md-4"/>
                            <AppSelect :value="currencyRate.currency_to"
                                       :options="currencies"
                                       track-by="code"
                                       label-field="code"
                                       label="To currency"
                                       placeholder=""
                                       field="to_code"
                                       :errors="errors"
                                       @input="updateCurrencyRateProps({
                                       currency_to: $event,
                                       to_code: $event ? $event.code : null,
                                       })"
                                       class="col-sm-6 col-md-4"/>
                            <AppInput label="Rate"
                                      :value="currencyRate.rate"
                                      field="rate"
                                      :errors="errors"
                                      @change="updateCurrencyRateProps({ rate: $event })"
                                      class="col-sm-6 col-md-4"/>
                        </div>
                        <div class="row">
                            <AppDatePicker :value="currencyRate.recorded_at"
                                           @input="updateCurrencyRateProps({ recorded_at: $event })"
                                           field="recorded_at"
                                           label="Recorded at"
                                           :errors="errors"
                                           class="col-sm-6 col-lg-5"/>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import AppInput from '../form/AppInput';
import AppSelect from '../form/AppSelect';
import AppDatePicker from '../form/AppDatePicker';
import AppPlaceholder from '../form/AppPlaceholder';
import Errors from '../../utils/errors';
import { formatDate } from '../../filters/date.filter';

export default {
  components: {
    AppInput,
    AppSelect,
    AppDatePicker,
    AppPlaceholder,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      canClose: false,
    };
  },

  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      currencyRate: 'currencyRates/currencyRate',
      currencies: 'currencyRates/currencies',
    }),
    isNew() {
      return this.$route.params.id === 'new';
    },
  },
  mounted() {
    this.getCurrencies();
    this.initCurrencyRate();
  },
  watch: {
    '$route.params.id'() {
      this.initCurrencyRate();
    },
  },
  methods: {
    initCurrencyRate() {
      return this.isNew
        ? this.$store.dispatch('currencyRates/newCurrencyRate')
        : this.getCurrencyRate();
    },
    getCurrencies() {
      this.$store.dispatch('currencyRates/getCurrencies');
    },
    getCurrencyRate() {
      this.$store.dispatch('currencyRates/getCurrencyRate', this.$route.params.id);
    },
    updateCurrencyRateProps(props) {
      this.$store.dispatch('currencyRates/updateCurrencyRateProps', props);
    },
    saveAndClose() {
      this.save()
        .then(() => {
          if (this.canClose) {
            this.$router.push({ name: 'currency-rates' });
          }
        });
    },
    save() {
      this.loading = true;
      this.errors.clear();
      return this.$store.dispatch(this.isNew ? 'currencyRates/createCurrencyRate' : 'currencyRates/updateCurrencyRate')
        .then((res) => {
          this.canClose = true;
          if (this.isNew) {
            this.$router.push({
              name: 'currency-rate',
              params: { id: res.currency_rate_id },
            });
          }
          NotificationService.success(res.message);
        })
        .catch((err) => {
          this.canClose = false;
          this.errors.set(err.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    destroy() {
      this.$bvModal.msgBoxConfirm('Delete currency rate?', {
        okTitle: 'Delete',
        okVariant: 'danger',
      })
        .then((value) => {
          if (value) {
            this.$store.dispatch('currencyRates/deleteCurrencyRate')
              .then((res) => {
                NotificationService.success(res.message);
                this.$router.push({ name: 'currency-rates' });
              });
          }
        });
    },
  },
};
</script>
